import { render, staticRenderFns } from "./transactionrecord.vue?vue&type=template&id=082f2fcc"
import script from "./transactionrecord.vue?vue&type=script&lang=js"
export * from "./transactionrecord.vue?vue&type=script&lang=js"
import style0 from "./transactionrecord.vue?vue&type=style&index=0&id=082f2fcc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports